import {
  Box,
  Button,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger
} from "@chakra-ui/react";
import * as Html from 'view-layer/styled/html';
import { currencyFormat } from 'business-layer/helpers/currencyFormat';
import { useContext, useState } from "react";
import { FaAngleDown } from "react-icons/fa6";
import {GenericKeyValue} from "../../../../business-layer/types";
import {L10nContext} from "../../../../business-layer/contexts/L10nContext";

interface PropsType {
  label: string,
  currency: string,
  amount: string | number,
  paymentFee?: null | number;
}

export const PropertyAmount = ({ label, currency, amount, paymentFee }: PropsType) => {
  const { labels }: { labels: GenericKeyValue } = useContext(L10nContext) as any;
  const newTotal = +amount + paymentFee!;
  const [showPopover, setShowPopover] = useState(false);

  const handlePopoverToggle = () => {
    setShowPopover(!showPopover);
  };


  return (
    <Box fontSize={'14px'} lineHeight={'20px'} pt={1} position={'relative'}>
      {paymentFee && paymentFee !== null ? (
        <>
          {label}: <>
            <Html.Strong position="relative" data-testid="amount-value">
              {currency.toLocaleLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `}{currencyFormat(newTotal)}
            </Html.Strong>
          </>
          <Popover
            isOpen={showPopover}
            onClose={handlePopoverToggle}
            data-testid="show-payment-details"
          >
          <PopoverTrigger>
            <Button
              onClick={handlePopoverToggle}
              size="sm"
              variant="link"
              color="blue"
              rightIcon={<FaAngleDown />}
              top="2px"
              data-testid="show-payment-details-button"
            ></Button>
          </PopoverTrigger>
          <PopoverContent
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              border: '1px solid #DDE0E4',
              boxShadow: '0px 0px 4px 4px rgba(0, 18, 56, 0.08)',
              top: '2px',
            }}
          >
            <PopoverBody>
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gridGap: '4px 0',
              }}
              >
                <span>{labels?.subtotal}</span>
                <span style={{justifySelf: 'end', fontWeight: '600'}} data-testid="convFee-subtotal">
                    <Html.Strong>{currency.toLocaleLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `}{currencyFormat(amount)}</Html.Strong>
                  </span>
                <span>{labels?.convenienceFee}</span>
                <span style={{justifySelf: 'end', fontWeight: '600'}} data-testid="convFee">
                    <Html.Strong>{currency.toLocaleLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `}{currencyFormat(paymentFee!)}</Html.Strong>
                  </span>
                <span>{labels?.grandTotal}</span>
                <span style={{justifySelf: 'end', fontWeight: '600'}} data-testid="convFee-total">
                    <Html.Strong>{currency.toLocaleLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `}{currencyFormat(newTotal)}</Html.Strong>
                  </span>
                <span
                  style={{
                    borderTop: '1px solid #DDE0E4',
                    fontSize: '14px',
                    fontWeight: 600,
                    paddingTop: '5px',
                  }}
                  data-testid="convFee-balance-due"
                >
                    {labels?.balanceDue}
                  </span>
                <span
                  style={{
                    borderTop: '1px solid #DDE0E4',
                    fontSize: '14px',
                    fontWeight: 600,
                    textAlign: 'right',
                    paddingTop: '5px',
                  }}
                  data-testid="convFee-new-total-payment"
                >
                   <Html.Strong>{currency.toLocaleLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `}{currencyFormat(newTotal)}</Html.Strong>
                  </span>
              </div>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </>
      ) : (
        <>
          {label}: <Html.Strong>{currency.toLocaleLowerCase() === 'usd' ? '$' : `${currency.toUpperCase()} `}{currencyFormat(amount)}</Html.Strong>
        </>
      )}
    </Box>
  );
};
